module.exports.GET_INCIDENT = 'GET_INCIDENT';
module.exports.ERROR_INCIDENT = 'ERROR_INCIDENT';
